export interface NightReportMetric {
  value: number;
  baseline?: number | null;
  deviation?: number | null;
  deviation_pct?: number | null;
  deviation_alert?: boolean | null;
}

export interface NightReport {
  subject?: NightReportSubject | null;
  device?: NightReportDevice | null;
  session_id?: string | null;
  timeframe_start: string;
  timeframe_end: string;
  report_date: string;
  state: "PRESENCE_AND_SLEEP" | "NO_PRESENCE" | "NO_SLEEP";
  selected_session_is_in_progress?: boolean | null;
  baseline_night_count?: number | null;
  respiration_rate?: NightReportMetric | null;
  movement?: NightReportMetric | null;
  time_asleep?: NightReportMetric | null;
  out_of_bed?: NightReportMetric | null;
  sleep_score?: NightReportMetric | null;
}
export interface NightReportDevice {
  id: string;
  type: string;
  serial_number?: string | null;
  name?: string | null;
}
export interface NightReportSubject {
  id: string;
  identifier: string;
  sex?: string | null;
  birth_year?: number | null;
}

export type NightReportTimes = { start?: string; end?: string };

export const DEFAULT_NIGHT_REPORT_START = "20:00";
export const DEFAULT_NIGHT_REPORT_END = "07:00";

export type AlertMetric = "respiration_rate" | "movement" | "time_asleep";

export interface INightReportFilterSettings {
  showOnlyBadNights: boolean;
}

export const hasDeviationAlert = (item: NightReport) => {
  return !!(
    item.respiration_rate?.deviation_alert ||
    item.movement?.deviation_alert ||
    item.time_asleep?.deviation_alert ||
    item.out_of_bed?.deviation_alert ||
    item.sleep_score?.deviation_alert
  );
};
